import i18n from "@/i18n";
import { ReactComponent as UploadErrorImage } from "@/assets/images/fileError.svg";
import { ReactComponent as DownloadIcon } from "@/assets/icons/downloadIcon.svg";
import React, { useRef } from "react";
import DataEntry from "@/components/DataEntry";
import FileIcon from "@/assets/icons/FileIcon";

interface ContentUploadErrorProps {
  fileName: string;
  fileExtension: string;
  uploadErrors: any;
}

const ContentUploadPartialSuccess = ({
  fileName,
  fileExtension,
  uploadErrors,
}: ContentUploadErrorProps) => {
  const hiddenDownloadButton = useRef<HTMLAnchorElement>(null);

  return (
    <div className="flex flex-col">
      <div className="flex flex-col md:flex-row items-center">
        <UploadErrorImage className="flex-1" />
        <div className="grow-1 flex flex-col mt-5 sm:mt-0 sm:ml-10 sm:w-48">
          <span className="text-body-regular-1 fill-current text-gray-700 text-center">
            {i18n.t("UPLOAD_FAILURE")}
          </span>
          <DataEntry.Button
            label={i18n.t("DOWNLOAD_SPREADSHEET")}
            color="secondary"
            onClick={() => hiddenDownloadButton.current?.click()}
            endIcon={<DownloadIcon fill="#2794F9" />}
            customStyles={{ marginTop: 3 }}
          />
          {uploadErrors && (
            <a
              href={URL.createObjectURL(uploadErrors)}
              download="erros.xlsx"
              className="hidden"
              ref={hiddenDownloadButton}
            />
          )}
        </div>
      </div>
      <div className="flex flex-row border-solid border border-red-700 rounded-md p-2 mt-6">
        <FileIcon text={fileExtension} />
        <span className="inline-block text-body-regular-1 fill-current text-black text-center mt-1 ml-3 align-items: center">
          {fileName}
        </span>
      </div>
      <span className="inline-block text-caption-regular-1 text-red-700 text-center mt-1">
        {i18n.t("FILE_NOT_UPLOADED_DOWNLOAD_SPREADSHEET")}
      </span>
    </div>
  );
};

export default ContentUploadPartialSuccess;
